import { createContext, useContext, useState, type ReactNode } from 'react'

interface FloatingChatState {
  personaName: string | null
  displayName: string | null
  isOpen: boolean
  prefillDraft: string | null
}

interface FloatingChatContextValue {
  chat: FloatingChatState
  openChat: (personaName: string, displayName?: string, prefillDraft?: string) => void
  closeChat: () => void
  toggleChat: () => void
}

const FloatingChatContext = createContext<FloatingChatContextValue | null>(null)

export function FloatingChatProvider({ children }: { children: ReactNode }) {
  const [chat, setChat] = useState<FloatingChatState>({
    personaName: null,
    displayName: null,
    isOpen: false,
    prefillDraft: null,
  })

  const openChat = (personaName: string, displayName?: string, prefillDraft?: string) => {
    setChat({ personaName, displayName: displayName || personaName, isOpen: true, prefillDraft: prefillDraft || null })
  }

  const closeChat = () => {
    setChat(prev => ({ ...prev, isOpen: false }))
  }

  const toggleChat = () => {
    setChat(prev => ({ ...prev, isOpen: !prev.isOpen }))
  }

  return (
    <FloatingChatContext.Provider value={{ chat, openChat, closeChat, toggleChat }}>
      {children}
    </FloatingChatContext.Provider>
  )
}

export function useFloatingChat() {
  const ctx = useContext(FloatingChatContext)
  if (!ctx) throw new Error('useFloatingChat must be used within FloatingChatProvider')
  return ctx
}
